/**
 * Minimal cleanup before rendering trusted server HTML in the app.
 * Does not replace a full sanitizer; keep email templates server-controlled.
 */
export function stripDangerousHtml(html) {
  if (!html || typeof html !== 'string') return '';
  return html
    .replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '')
    .replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '');
}

export function isProbablyHtml(s) {
  return typeof s === 'string' && /<[a-z][\s\S]*>/i.test(s);
}
